import React from 'react'
import PropTypes from 'prop-types'
import {
  CardActions,
  ExportButton
} from 'react-admin'
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys'

import RegisterUserAction from './RegisterUserAction'

const Actions = ({
   bulkActions,
   basePath,
   currentSort,
   displayedFilters,
   exporter,
   filters,
   filterValues,
   onUnselectItems,
   resource,
   selectedIds,
   showFilter,
   total,
   data
}) => {
  return (
    <CardActions>
      {bulkActions && React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems
      })}
      {filters && React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      }) }
      <RegisterUserAction record={data} />
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
      />
    </CardActions>
  )
}

Actions.propTypes = {
  basePath: PropTypes.string,
  displayedFilters: PropTypes.object,
  filters: PropTypes.element,
  filterValues: PropTypes.object,
  hasCreate: PropTypes.bool,
  resource: PropTypes.string,
  showFilter: PropTypes.func,
  theme: PropTypes.object
}

export default onlyUpdateForKeys([
  'resource',
  'filters',
  'displayedFilters',
  'filterValues',
  'theme'
])(Actions)
